import { Check } from '@mui/icons-material';
import { TextField } from '@mui/material';
import { ChangeEventHandler, Dispatch, SetStateAction } from 'react';

function formatMac(value: string) {
  return (
    value
      .toUpperCase()
      .replace(/[^0-9A-F]/g, '') // remove non-hex chars
      .slice(0, 12) // max 12 hex chars
      .match(/.{1,2}/g) // split into pairs
      ?.join(':') || ''
  );
}

interface MACFormatterFieldProps {
  mac: string;
  setMac: Dispatch<SetStateAction<string>>;
  errorText?: string;
  onMacChange?: (value: string) => void;
}

export default function MacInput({
  mac,
  setMac,
  errorText,
  onMacChange,
}: MACFormatterFieldProps) {
  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const nextValue = formatMac(e.target.value);
    setMac(nextValue);
    onMacChange?.(nextValue);
  };

  return (
    <TextField
      type="text"
      value={mac}
      onChange={handleChange}
      placeholder="AA:BB:CC:DD:EE:FF"
      label="MAC Address"
      variant="outlined"
      fullWidth
      sx={{ mb: 2 }}
      error={Boolean(errorText)}
      helperText={errorText}
      // max length of 17 characters (12 hex + 5 colons)
      slotProps={{
        htmlInput: {
          maxLength: 17,
        },
        input: {
          endAdornment:
            mac.length === 17 ? (
              <Check sx={{ color: 'success.main' }} />
            ) : undefined,
        },
      }}
    />
  );
}
